<header class="topbar">
  <nav class="d-flex top-navbar navbar-expand-md navbar-light p-0">
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- End Logo -->
    <!-- ============================================================== -->

    <div class="navbar-collapse" height="10" style="box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08)">
      <!-- ============================================================== -->
      <!-- toggle and nav items -->
      <!-- ============================================================== -->

      <div class="col-2">
        <ul class="navbar-nav mt-md-0">
          <!-- This is  -->
          <li (click)="toggleSidebar.emit()" class="nav-item m-l-10">
            <a style="color: #d1313c" href="javascript:void(0)"><i class="ti-menu"></i></a>
          </li>
        </ul>
      </div>

      <div class="col-8 text-center">
        <img class="" src="assets/images/Logo.png" alt="homepage" height="30" />
      </div>

      <div class="col-2">
        <ul class="navbar-nav my-lg-0 row justify-content-end align-items-center">
          <!--<li class="nav-item d-flex align-items-center mr-2">
            <a class="nav-link theme-toggle p-0" href="javascript:void(0)" (click)="themeService.toggle()" title="Cambiar tema">
              <span class="toggle-track" [class.dark]="themeService.isDark">
                <span class="toggle-icon toggle-sun">
                  <i class="ti-shine"></i>
                </span>
                <span class="toggle-icon toggle-moon">
                  <i class="ti-cloud"></i>
                </span>
                <span class="toggle-thumb"></span>
              </span>
            </a>
          </li>-->
          <li class="nav-item dropdown" ngbDropdown placement="bottom-right">
            <a ngbDropdownToggle class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
              <img src="assets/images/users/Avatars.png" alt="user" class="profile-pic" />
              <span *ngIf="!requestServ.esMovil">
                {{ requestServ.empresa }}
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right menu" ngbDropdownMenu style="width: auto">
              <ul class="dropdown-user">
                <li class="company-search"> <input (input)="filter = $event.target.value" class="form-control" placeholder="Buscar por nombre ..." type="text"></li>
                <li
                  *ngFor="let item of empresas | multifilter  : ['nombre'] : filter  ; let i = index"
                  [class.company-disabled]="item.expirado"
                >
                  <div class="dw-user-box mt-0">
                    <div
                      ngbDropdownToggle
                      [style.cursor]="item.expirado ? 'not-allowed' : 'pointer'"
                      (click)="!item.expirado && cambiarEmpresa(item.id)"
                      class="u-text text-center"
                    >
                      <div class="flex-row d-flex align-content-center">
                        <div class="dot d-flex align-content-center justify-content-center">
                          <span class="align-self-center">
                            {{ item.nombre[0] + item.nombre[1].toUpperCase() }}
                          </span>
                        </div>
                        <h4 class="align-self-center ml-2 mb-0">
                          {{ item.nombre }}
                        </h4>
                        <span *ngIf="item.expirado" class="badge-expirada ml-2 align-self-center">
                          Expirada
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
